<template lang="pug">
v-card(flat)
  v-card-text
    v-form(ref="form" v-model="valid" lazy-validation)
      v-row
        v-col(cols="12" sm="6")
          v-text-field(
            v-model="editedItem.full_name"
            :rules="[inputRules.requiredInput]"
            label="Nombre completo")
        v-col(cols="12" sm="6")
          v-text-field(
            v-model="editedItem.email"
            :rules="[inputRules.requiredInput]"
            label="Correo electrónico"
            type="email")
        v-col(v-if="!isEditing" cols="12")
          v-text-field(
            v-model="editedItem.password"
            :rules="[inputRules.requiredInput]"
            label="Contraseña"
            type="password")
        v-col(cols="12" sm="6")
          v-text-field(v-model="editedItem.vur_user" label="Usuario VUR")
        v-col(cols="12" sm="6")
          v-text-field(
            v-model="editedItem.vur_password"
            label="Contraseña VUR"
            type="password")
        v-col(cols="12")
          v-autocomplete(
            v-model="editedItem.permissions"
            :items="availablePermissions"
            item-value="value"
            item-text="text"
            label="Permisos"
            multiple
            chips)
        v-col(cols="12" sm="6")
          v-switch(
            v-model="editedItem.is_active"
            :disabled="isSelf"
            label="Usuario activo")
        v-col(cols="12" sm="6")
          v-switch(
            v-model="editedItem.is_superuser"
            :disabled="isSelf"
            label="Es superusuario")
  v-divider
  v-card-actions
    v-btn(:loading="loading" @click="close" text) Cerrar
    v-spacer
    v-btn(:loading="loading" color="primary" @click="save" text) Guardar
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';

const defaultItem = {
  id: '',
  full_name: '',
  email: '',
  password: '',
  is_active: true,
  is_superuser: false,
  vur_user: '',
  vur_password: '',
  permissions: [],
};

export default {
  name: 'UserForm',

  data: () => ({
    loading: false,
    valid: true,
    editedItem: { ...defaultItem },
    availablePermissions: [
      { text: 'Agregar folios', value: 'can_add_folio' },
      { text: 'Eliminar folios', value: 'can_delete_folio' },
      { text: 'VUR masivo', value: 'can_massive_vur' },
      { text: 'Editar documentos', value: 'can_change_document' },
      { text: 'Eliminar documentos', value: 'can_delete_document' },
      { text: 'Credenciales VUR', value: 'can_change_vur' },
    ],
  }),

  computed: {
    ...mapState('ui', ['inputRules', 'showDialog', 'currentProperties']),
    isEditing() {
      return this.editedItem.id !== '';
    },
    isSelf() {
      return this.isEditing && this.currentProperties.user
        && this.currentProperties.currentUserEmail === this.currentProperties.user.email;
    },
  },

  watch: {
    showDialog: {
      handler(showDialog) {
        if (!showDialog) return;
        this.editedItem = this.currentProperties.user
          ? { ...this.currentProperties.user, password: '', permissions: [...this.currentProperties.user.permissions] }
          : { ...defaultItem };
      },
      immediate: true,
    },
  },

  methods: {
    ...mapMutations('ui', ['TOGGLE_DIALOG']),
    ...mapActions('users', ['createUser', 'updateUser']),
    close() {
      this.editedItem = { ...defaultItem };
      this.TOGGLE_DIALOG(false);
    },
    async save() {
      if (!this.$refs.form.validate()) return;
      this.loading = true;
      let result;
      if (this.isEditing) {
        const userData = { ...this.editedItem };
        delete userData.password;
        result = await this.updateUser(userData);
      } else {
        result = await this.createUser(this.editedItem);
      }
      this.loading = false;
      if (result.updated || result.created) {
        this.$emit('saved');
        this.close();
      }
    },
  },
};
</script>
